<template>
    <div class="container">
        <div class="content">
            <div v-html="footerHtmlText"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

const props = defineProps<{
    itemData: {
        htmlText: string | Record<string, string>
    }
}>()
const footerHtmlText = computed(() => resolveText(props.itemData.htmlText))
</script>
<style scoped>
.container {
    padding: 5px 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    background: rgb(2, 74, 73);
    font-weight: 400;
    font-family: system-ui;
}
@media (max-width : 420px){
    .container{
       font-size: 14px; 
    }
}
</style>